import React , {useEffect} from "react";
import { Container, Row, Col } from "shards-react";

import PageTitle from "../../components/common/PageTitle"; 
// import UserDetails from "../components/user-profile-lite/UserDetails";
import F_SAV from "../SuiviClassic/F_SuiviClassic";


const EditMiseEnService = (props) => { 

/// const location = useLocation();
  
  useEffect(() => {
  //  console.log( location.info );

 }, []);

 // alert (location.info)

 return (

  <Container fluid className="main-content-container px-4">
  <Row noGutters className="page-header py-4">
  <PageTitle sm="4" title="Suivi Classique" subtitle="Liste de saisies" className="text-sm-left" />
  </Row>
  
  <Row>
    
    <Col lg="12">

      <F_SAV Donnees = {"oooooooooo"} />

    </Col>
 
  </Row>
</Container>

 )
};



export default EditMiseEnService;
